import { defineNuxtPlugin } from 'nuxt/app'
import { createServerClient, ServerClient } from '~/api/serverClient'
import { ServerClientKey } from '~/api/symbols'

declare module 'vue' {
  interface ComponentCustomProperties {
    $server: ServerClient
  }
}
declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $server: ServerClient
  }
}

export default defineNuxtPlugin((nuxtApp) => {
  const server = createServerClient()
  nuxtApp.provide('server', server)
  nuxtApp.vueApp.provide(ServerClientKey, server)
})
